import DialogComponent from "components/Dialog";

import SelectDatePeriod from "components/SelectDatePeriod";

export default class TransferDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: false,
        };
    }

    title = "Отложить звонок";

    show(info, hideCb) {
        this.state.info = info;
        this.dialogSaveLabel = "Отложить";
        this.hidCb = hideCb;
        super.show();
    }

    save() {
        const info = {
            remindBefore: this._helper.date.setTime(this.selectDatePeriod.value, "23:59"),
            comment: this.inpComm.value,
            id: this.state.info.id
        };

        if (this.hidCb?.apply)
            this.hidCb(info);

        this.hide();
    }

    renderContent() {
        //const { info } = this.state;

        return (
            <div className="content flex col gap16">
                <SelectDatePeriod
                    ref={el => this.selectDatePeriod = el}
                    label="Отложить звонок на дату"
                    onChange={null} />
                {this.insertTextarea({
                    ref: el => this.inpComm = el,
                    label: "main.comment",
                    placeHolder: "main.freeComment"

                })
                }
            </div>
        );
    }
}

